import React from "react";
import { useRouter } from "next/router";
import Link from "next/link";
import classnames from "classnames";

import { routePath } from "shared/helpers/routePath";
import styles from "shared/components/AppBar/components/NavBar/NavBar.module.scss";

export const AccountSubNav: React.FC = () => {
  const router = useRouter();
  const isSettings = router.route === routePath.ACCOUNT_SETTINGS.href;
  const isBookmarked = router.route === routePath.ACCOUNT_BOOKMARKED.href;
  const isFollowed = router.route === routePath.ACCOUNT_FOLLOWED.href;
  const portal = process.env.NEXT_PUBLIC_PORTAL;

  return (
    <>
      <Link href={routePath.ACCOUNT_FOLLOWED.href}>
        <a
          className={classnames(styles.link, styles[portal], {
            [styles.active]: isFollowed,
          })}
        >
          {routePath.ACCOUNT_FOLLOWED.label}
        </a>
      </Link>

      <Link href={routePath.ACCOUNT_BOOKMARKED.href}>
        <a
          className={classnames(styles.link, styles[portal], {
            [styles.active]: isBookmarked,
          })}
        >
          {routePath.ACCOUNT_BOOKMARKED.label}
        </a>
      </Link>

      <Link href={routePath.ACCOUNT_SETTINGS.href}>
        <a
          className={classnames(styles.link, styles[portal], {
            [styles.active]: isSettings,
          })}
        >
          {routePath.ACCOUNT_SETTINGS.label}
        </a>
      </Link>
    </>
  );
};

export default AccountSubNav;
